<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <fakturyMenu></fakturyMenu>
                <div class="widget-heading"></div>
                <div class="widget-content">
                    <div class="row mb-4 g-2 align-items-end">
                        <!-- Rok -->
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Rok</label>
                            <select v-model="selectedYearInternal" @change="changePeriod" class="form-select">
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                            </select>
                        </div>

                        <!-- Miesiąc -->
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Miesiąc</label>
                            <select v-model="selectedMonthInternal" @change="changePeriod" class="form-select">
                                <option value="0">Wszystkie</option>
                                <option v-for="(name, index) in months" :key="index" :value="index+1">{{ name }}</option>
                            </select>
                        </div>

                        <!-- Szukaj -->
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Szukaj</label>
                            <input v-model="search" type="text" placeholder="Szukaj..." class="form-control" />
                        </div>

                        <!-- Ilość na stronę -->
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Na stronę</label>
                            <select v-model="perPage" @change="changePerPage" class="form-select">
                                <option v-for="opt in perPageOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                            </select>
                        </div>

						<div class="col-12 col-sm-4 col-md-4">
							<label class="form-label d-none d-md-block">&nbsp;</label>

							<div class="d-flex gap-2">
                    <!--       <input
    ref="fakturaFile"
    type="file"
    class="d-none"
    accept=".xml,.zip,.xlsx,.xls,.csv"
    @change="uploadFakturaFile"
/>

<button
    class="btn btn-success"
    :disabled="importing"
    @click="$refs.fakturaFile.click()"
>
    <i class="bi bi-upload me-2"></i>
    {{ importing ? 'Importuję...' : 'Wczytaj plik xml faktury' }}
</button> -->
								<a :href="route('kadry.zestawienie_faktur_out.pdf', {year: selectedYearInternal, month: selectedMonthInternal})"
								   target="_blank"
								   class="btn btn-info flex-fill">
									<i class="bi bi-file-earmark-pdf me-2"></i>Lista PDF
								</a>

								<a :href="route('kadry.zestawienie_faktur_out.xlsx', {year: selectedYearInternal, month: selectedMonthInternal})"
								   target="_blank"
								   class="btn btn-success flex-fill">
									<i class="bi bi-file-earmark-xlsx me-2"></i>Lista XLSX
								</a>
							</div>
						</div>						
						

                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th @click="sortBy('faktura_numer')">Numer faktury</th>
                                    <th @click="sortBy('data_sprzedazy')">Data sprzedaży</th>
                                    <th @click="sortBy('data_utworzenia')">Data utworzenia</th>
                                    <th @click="sortBy('waluta')">Waluta</th>
                                    <th @click="sortBy('customer_name')">Klient</th>
                                    <th @click="sortBy('info')">Informacja</th>
                                    <th @click="sortBy('printed')">Wydrukowana</th>
                                    <th>Opcje</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="faktura in paginatedFaktury" :key="faktura.id">
                                    <td>{{ faktura.faktura_numer }}</td>
                                    <td class="align-items-center">{{ faktura.data_sprzedazy }}</td>
                                    <td class="align-items-center">{{ faktura.data_utworzenia }}</td>
                                    <td class="align-items-center">{{ faktura.waluta }}</td>
                                    <td>{{ faktura.customer_name }}</td>
                                    <td>
                                        <div style="white-space: pre-line;">

                                            {{ faktura.info }}
                                        </div>
                                        <button @click="openModalInfo(faktura)" class="btn btn-xs btn-outline-info mt-1 me-2"><i class="bi bi-pencil"></i></button>

                                    </td>
                                    <td class="align-items-center">
                                        <select class="form-select form-select-xs" v-model.number="faktura.printed" @change="updatePrinted(faktura)" :style="{ color: faktura.printed == 1 ? 'green' : 'red', fontWeight: 'bold' }">
                                            <option :value="0" :style="{ color:'red', fontWeight: 'bold' }">✖ Nie</option>
                                            <option :value="1" :style="{ color: 'green', fontWeight: 'bold' }">✔ Tak</option>
                                        </select>
                                    </td>
                                    <td class="align-items-center">
                                        <a :href="faktura.faktura_upo" target="_blank" class="btn btn-info btn-sm ms-2 mb-2 me-2">
                                            <i class="bi bi-file-earmark-pdf"></i>Pobierz
                                        </a>
                                     </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                        <div class="mb-2">
                            <button class="btn btn-outline-secondary btn-sm me-1" :disabled="page <= 1" @click="goToPage(page-1)">
                                « Poprzednia
                            </button>

                            <button
                                v-for="p in pageNumbers"
                                :key="p"
                                class="btn btn-sm me-1"
                                :class="p === page ? 'btn-primary' : 'btn-outline-secondary'"
                                @click="goToPage(p)">
                                {{ p }}
                            </button>

                            <button class="btn btn-outline-secondary btn-sm" :disabled="page >= lastPage" @click="goToPage(page+1)">
                                Następna »
                            </button>
                        </div>

                        <div class="mb-2">
                            Strona {{ page }} / {{ lastPage }} | Łącznie {{ total }} rekordów
                        </div>
                    </div>

                    <div v-if="isModalOpenInfo" class="modal fade show" tabindex="-1" style="display:block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">

                                <div class="modal-header">
                                    <h5 class="modal-title">Opis dla księgowości</h5>
                                    <button type="button" class="btn-close" @click="closeModalInfo"></button>
                                </div>

                                <div class="modal-body">
                                    <textarea
                                        v-model="editingInfo"
                                        class="form-control"
                                        rows="6"
                                        placeholder="Wpisz opis dla księgowości..."></textarea>
                                </div>

                                <div class="modal-footer">
                                    <button class="btn btn-secondary" @click="closeModalInfo">Anuluj</button>
                                    <button class="btn btn-primary" @click="saveInfo">Zapisz</button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div v-if="isModalOpenOpis" class="modal fade show" tabindex="-1" style="display:block; background: rgba(0,0,0,0.5);">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">

                                <div class="modal-header">
                                    <h5 class="modal-title">Opis faktury</h5>
                                    <button type="button" class="btn-close" @click="closeModalOpis"></button>
                                </div>

                                <div class="modal-body">
                                    <pre class="p-2 bg-light border rounded" style="white-space: pre-wrap; word-break: break-word;">
                                    {{ (currentOpis || '').trim() }}
                                    </pre>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-secondary" @click="closeModalOpis">Zamknij</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from "@/Layouts/App.vue";
    import axios from "axios";
	import fakturyMenu from "@/Pages/Kadry/parts/fakturyMenu.vue";
	
    export default {
        components: {AppLayout, fakturyMenu},
        props: {
            selectedYear: Number,
            selectedMonth: Number,
        },

        data() {
            return {
                importing: false,
				selectedFile: null,
                isModalOpenInfo: false,
                editingFakturaId: null,
                isModalOpenOpis: false,
                currentOpis: '',
                editingInfo: '',
                allFaktury: [],
                filteredFaktury: [],
                search: "",
                sortKey: localStorage.getItem("faktury_sortKey") || "data_utworzenia",
                sortAsc: localStorage.getItem("faktury_sortAsc") === "false" ? false : true,
                selectedYearInternal: this.selectedYear,
                selectedMonthInternal: this.selectedMonth,
                page: 1,
                perPage: 25,
                total: 0,
                perPageOptions: [{
                        label: '25 wyników',
                        value: 25
                    },
                    {
                        label: '50 wyników',
                        value: 50
                    },
                    {
                        label: '100 wyników',
                        value: 100
                    },
                    {
                        label: 'Wszystkie',
                        value: 0
                    }
                ],
                years: [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2],
                months: [
                    "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
                    "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"
                ],
            };
        },

        computed: {
            paginatedFaktury() {
                if (this.perPage === 0) return this.filteredFaktury;
                const start = (this.page - 1) * this.perPage;
                return this.filteredFaktury.slice(start, start + this.perPage);
            },

            lastPage() {
                if (this.perPage === 0) return 1;
                return Math.ceil(this.filteredFaktury.length / this.perPage);
            },

            pageNumbers() {
                const numbers = [];
                const start = Math.max(this.page - 2, 1);
                const end = Math.min(start + 4, this.lastPage);
                for (let i = start; i <= end; i++) numbers.push(i);
                return numbers;
            }
        },

        watch: {
            search() {
                this.applyFilters();
            }
        },

        methods: {
            openOpisModal(opis) {
                this.currentOpis = opis || '';
                this.isModalOpenOpis = true;
            },

            closeModalOpis() {
                this.isModalOpenOpis = false;
                this.currentOpis = '';
            },

            async saveInfo() {
                try {
                    await axios.post(`/kadry/faktury_out/update_info/${this.editingFakturaId}`, {
                        info: this.editingInfo
                    });

                    const faktura = this.allFaktury.find(f => f.id === this.editingFakturaId);
                    if (faktura) {
                        faktura.info = this.editingInfo;
                    }

                    //this.applyFilters();
                    this.closeModalInfo();

                    this.showToast('success', 'Zapisano', 'Opis został zapisany.');
                } catch (e) {
                    console.error(e);
                    this.showToast('error', 'Błąd', 'Nie udało się zapisać opisu.');
                }
            },

            openModalInfo(faktura) {
                this.editingFakturaId = faktura.id;
                this.editingInfo = faktura.info || '';
                this.isModalOpenInfo = true;
            },

            closeModalInfo() {
                this.isModalOpenInfo = false;
                this.editingFakturaId = null;
                this.editingInfo = '';
            },

            async fetchFaktury() {
                try {
                    const res = await axios.get("/kadry/faktury_out/get", {
                        params: {
                            year: this.selectedYearInternal,
                            month: this.selectedMonthInternal || null,
                        }
                    });

                    // upewniamy się, że printed jest liczbą
                    this.allFaktury = res.data.data.map(f => ({
                        ...f,
                        printed: Number(f.printed) || 0 // jeśli undefined, ustawiamy 0
                    }));

                    this.total = this.allFaktury.length;
                    this.applyFilters();

                } catch (error) {
                    console.error("Błąd pobierania faktur:", error);
                }
            },

            applyFilters() {
                let f = [...this.allFaktury];

                // frontendowy search
                if (this.search) {
                    const s = this.search.toLowerCase();
                    f = f.filter(x =>
                        (x.faktura_numer && x.faktura_numer.toLowerCase().includes(s)) ||
                        (x.customer_name && x.customer_name.toLowerCase().includes(s)) ||
                        (x.waluta && x.waluta.toLowerCase().includes(s)) ||
                        (x.data_sprzedazy && x.data_sprzedazy.includes(s)) ||
                        (x.data_utworzenia && x.data_utworzenia.includes(s)) ||
                        (x.printed != null && String(x.printed).includes(s)) ||
                        (x.info && x.info.toLowerCase().includes(s))
                    );
                }

                // frontendowe sortowanie
                if (this.sortKey) {
                    f.sort((a, b) => {

                        let valA = a[this.sortKey] ?? "";
                        let valB = b[this.sortKey] ?? "";

                        // ✅ specjalna obsługa daty DD.MM.YYYY
                        if (this.sortKey === "data_sprzedazy" || this.sortKey === "data_utworzenia") {
                            const parseDate = (str) => {
                                if (!str) return new Date(0);
                                const [day, month, year] = str.split(".");
                                return new Date(year, month - 1, day);
                            };

                            valA = parseDate(valA);
                            valB = parseDate(valB);
                        }

                        // stringi
                        else if (typeof valA === "string") {
                            valA = valA.toLowerCase();
                            valB = valB.toLowerCase();
                        }

                        if (valA < valB) return this.sortAsc ? -1 : 1;
                        if (valA > valB) return this.sortAsc ? 1 : -1;
                        return 0;
                    });
                }

                this.filteredFaktury = f;
                this.page = 1; // reset strony po filtrze
            },

            sortBy(key) {
                if (this.sortKey === key) this.sortAsc = !this.sortAsc;
                else {
                    this.sortKey = key;
                    this.sortAsc = true;
                    this.sortKey = key;
                }
                localStorage.setItem("faktury_sortKey", this.sortKey);
                localStorage.setItem("faktury_sortAsc", this.sortAsc);
                this.applyFilters();
            },

            changePeriod() {
                this.page = 1;
                this.fetchFaktury();
            },

            changePerPage() {
                this.page = 1;
            },

            goToPage(page) {
                if (page < 1 || page > this.lastPage) return;
                this.page = page;
            },

            async updatePrinted(faktura) {
                try {
                    await axios.post(`/kadry/faktury_out/printed/${faktura.id}`, {
                        printed: faktura.printed
                    });
                    this.showToast('success', 'Uwaga!', 'Status wydruku faktury został zmieniony.');
                } catch (error) {
                    alert("Nie udało się zaktualizować statusu wydrukowanej faktury");
                }
            },

            showToast(icon, title, message) {
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon: icon,
                    title: title,
                    html: message,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true
                });
            },

async uploadFakturaFile(event) {
    const file = event.target.files[0];

    if (!file) {
        return;
    }

    this.importing = true;

    try {
        const formData = new FormData();
        formData.append('file', file);

        const res = await axios.post(
            '/kadry/faktury_out/import',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        if (res.data.success) {
            this.showToast(
                'success',
                'Import',
                res.data.message || 'Plik został zaimportowany'
            );

            await this.fetchFaktury();
        } else {
            this.showToast(
                'error',
                'Błąd',
                res.data.message || 'Import nie powiódł się'
            );
        }

    } catch (error) {
        console.error(error);

        this.showToast(
            'error',
            'Błąd',
            'Nie udało się zaimportować pliku'
        );
    } finally {
        this.importing = false;
        event.target.value = '';
    }
},

        },

        mounted() {
            this.fetchFaktury();
        }
    };
</script>

<style scoped>
    .table th {
        cursor: pointer;
    }
</style>